import { Component } from '@angular/core';
import { NavParams, Events } from 'ionic-angular';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { ShareButtons } from '@ngx-share/core';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
/**
 * Generated class for the CoSocialMediaButtonsPopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-social-media-buttons-popover',
  templateUrl: 'co-social-media-buttons-popover.html'
})
export class CoSocialMediaButtonsPopoverComponent {

  event: any;
  eventUrl: string;
  clientKeyword: string;
  imageUrl: string;
  constructor(public navParams: NavParams, private clientDetails: ClientDetailsProvider, public share: ShareButtons, private events : Events, private timeout : TimeoutFunctionsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.event = this.navParams.data.event;
    let self = this;
    this.clientDetails.load().then((response) =>{
      self.clientKeyword = response.keyword;
      self.eventUrl = `https://${this.clientKeyword}.libnet.info/event/${this.event.eventId}`;
      self.imageUrl = `https://${this.clientKeyword}.libnet.info/images/events/${this.clientKeyword}/${this.event.eventImage}`
    });
  }

}



// WEBPACK FOOTER //
// ./src/components/co-social-media-buttons-popover/co-social-media-buttons-popover.ts